import React from 'react';
import { useSingleSaleTableItemTypeStyles } from 'components/Payments/SingleSale/Table/Item/Type/SingleSaleTableItemType.styles';
import { OrderizableTypes } from '@spike/order-model';
import { SingleChip } from 'components/UI';
import clsx from 'clsx';

export interface ItemTypeProps {
    type: OrderizableTypes;
    className?: string;
}

const labels: Map<OrderizableTypes, string> = new Map([
    [OrderizableTypes.PRODUCT, 'Product'],
    [OrderizableTypes.ADDON_SERVICE, 'Add-on'],
    [OrderizableTypes.CUSTOM, 'Custom']
]);

export const SingleSaleTableItemType: React.FC<ItemTypeProps> = props => {
    const classes = useSingleSaleTableItemTypeStyles();

    return (
        <SingleChip
            className={clsx(
                classes.default,
                { [classes.product]: props.type === OrderizableTypes.PRODUCT },
                {
                    [classes.addOnService]: props.type === OrderizableTypes.ADDON_SERVICE
                },
                { [classes.custom]: props.type === OrderizableTypes.CUSTOM }
            )}
        >
            {labels.get(props.type) || '-'}
        </SingleChip>
    );
};
